export default __webpack_public_path__ + "static/media/WinterBook_01.473658ea.png";